import BigNumber from 'bignumber.js';

export type VolatileAssetRole = 'borrow' | 'collateral';

interface CalculateLiquidationPriceParams {
  volatileAssetRole: VolatileAssetRole;
  variableAssetAmount: string;
  counterPositionValueInMarketReferenceCurrency: string;
  liquidationThreshold: string;
}

/** Calculates the volatile asset's liquidation price in the market reference currency. */
export function calculateLiquidationPrice({
  volatileAssetRole,
  variableAssetAmount,
  counterPositionValueInMarketReferenceCurrency,
  liquidationThreshold,
}: CalculateLiquidationPriceParams): string {
  const amount = new BigNumber(variableAssetAmount);
  const counterPositionValue = new BigNumber(counterPositionValueInMarketReferenceCurrency);
  const threshold = new BigNumber(liquidationThreshold);

  if (
    !amount.isFinite() ||
    amount.lte(0) ||
    !counterPositionValue.isFinite() ||
    counterPositionValue.lt(0) ||
    !threshold.isFinite() ||
    threshold.lte(0)
  ) {
    return '0';
  }

  // A borrowed volatile asset liquidates on a price rise; volatile collateral liquidates on a fall.
  return volatileAssetRole === 'borrow'
    ? counterPositionValue.multipliedBy(threshold).dividedBy(amount).toString()
    : counterPositionValue.dividedBy(threshold).dividedBy(amount).toString();
}
